import * as tslib_1 from "tslib";
import util from '@/lib/util';
var activity = {
    namespaced: true,
    state: {
        signUpJumpUrl: JSON.parse(localStorage.getItem('SignUpJumpUrl')) || '',
        activityInfo: {},
        jumpStatus: util.string2Boolean(localStorage.getItem('JumpStatus')) || false,
    },
    mutations: {
        setJumpUrl: function (state, url) {
            localStorage.setItem('SignUpJumpUrl', JSON.stringify(url));
            state.signUpJumpUrl = url;
        },
        setIsJumpStatus: function (state, status) {
            localStorage.setItem('JumpStatus', status.toString());
            state.jumpStatus = status;
        }
    },
    actions: {
        GetActivityById: function (_a, payload) {
            var state = _a.state;
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var rep;
                return tslib_1.__generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, abp.ajax.get('/api/services/app/Activity/GetActivityById?id=' + payload.id)];
                        case 1:
                            rep = _b.sent();
                            state.activityInfo = {};
                            state.activityInfo = rep.data.result;
                            return [2 /*return*/];
                    }
                });
            });
        }
    }
};
export default activity;
